(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    const collectionWrapper = document.querySelector('.collection-wrapper');
    if (!collectionWrapper) return;

    const topbar = collectionWrapper.querySelector('.facets-topbar');
    const headerGroup = document.getElementById('header-group');

    // --header-group-height counts the whole header group, including rows that
    // scroll away (announcement bar, nav). Only the pinned rows should offset
    // the sticky filters, so measure them directly.
    const getPinnedHeaderHeight = () => {
      if (!headerGroup) return 0;

      let offset = 0;
      for (const child of headerGroup.children) {
        const styles = getComputedStyle(child);
        if (styles.position !== 'sticky' && styles.position !== 'fixed') continue;

        const edge = child.getBoundingClientRect().height + (parseFloat(styles.top) || 0);
        offset = Math.max(offset, edge);
      }

      return Math.max(0, Math.round(offset));
    };

    let lastHeaderOffset = null;
    let lastControlsHeight = null;

    const updateStickyOffsets = () => {
      const headerOffset = getPinnedHeaderHeight();
      if (headerOffset !== lastHeaderOffset) {
        lastHeaderOffset = headerOffset;
        collectionWrapper.style.setProperty('--collection-sticky-top', `${headerOffset}px`);
      }

      const controlsHeight = Math.round(topbar?.getBoundingClientRect().height || 0);
      if (controlsHeight !== lastControlsHeight) {
        lastControlsHeight = controlsHeight;
        collectionWrapper.style.setProperty('--collection-sticky-controls-height', `${controlsHeight}px`);
      }
    };

    let scheduled = false;
    const scheduleUpdate = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        updateStickyOffsets();
      });
    };

    updateStickyOffsets();
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    window.addEventListener('scroll', scheduleUpdate, { passive: true });

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(scheduleUpdate);
      if (topbar) observer.observe(topbar);
      if (headerGroup) observer.observe(headerGroup);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
